import { HistogramConfigurationProviderProps } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { HistogramPanelData } from 'features/drilldown/components/histogram/DrilldownHistogram'

const LATEST_DATA_SCHEMA_VERSION = 3

export const DEFAULT_INSPECTION_TYPE_HISTOGRAM_PANEL_DATA: HistogramPanelData =
  {
    panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
    title: 'Inspection Types',
    isPinned: true,
    selectedBarIds: [],
    groupingColumn: 'inspection.inspection_type',
    aggregationColumn: 'inspection.id',
    aggregationOperation: 'count',
  }

export const INSPECTION_TYPE_HISTOGRAM_CONFIG_PROPS: HistogramConfigurationProviderProps =
  {
    defaultPanelData: DEFAULT_INSPECTION_TYPE_HISTOGRAM_PANEL_DATA,
    latestDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  }
